/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fetchUserProductSelectionsRequestActionCreator, deleteUserProductSelectionRequestActionCreator } from '../../../user/redux/actions/UserActions';
import { mailClassSelected } from '../redux/actions/ProductActions';
import DeleteModal from '../../../common/components/DeleteModal';
import Icons from '../../../../core/modules/common/components/Icons';
import { createProductPresetSelections } from '../../../react-table/helpers/utils';

const mapStateToProps = state => ({
  selections: state.productSelector.selections,
  mailClassNodes: state.productSelector.mailClassNodes,
});

export class ProductSelectionHeaderBarContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeSelection: '',
      showDeleteSelectionModal: false,
      name: '',
    };
  }

  componentDidMount() {
    this.props.fetchUserProductSelectionsRequestActionCreator();
  }

  onCloseModal = () => {
    this.setState({
      showDeleteSelectionModal: false,
    });
  };

  applySelection = (e, { name, products }) => {
    // eslint-disable-next-line max-len
    const productSelectionsTransformed = createProductPresetSelections(products, this.props.mailClassNodes);
    productSelectionsTransformed.forEach(product => (
      this.props.mailClassSelected(
        product.mailCategoryCode,
        product.mailSubClasses,
        this.props.categoryOnlySelection,
      )));
    this.setState({
      activeSelection: name,
    });
  };

  openDeleteSelectionModal = (e, selection) => {
    this.setState({
      name: selection.name,
      showDeleteSelectionModal: true,
    });
  };

  deleteSelection = () => {
    this.props.deleteUserProductSelectionRequestActionCreator(this.state.name);
    this.onCloseModal();
  };

  render() {
    const {
      selections,
    } = this.props;

    return (
      <div className="preset-div">
        {selections && selections.length > 0 ? (
          <div className="product-selection-navigation">
            {this.state.showDeleteSelectionModal &&
            <DeleteModal
              headerFormattedMessageId="app.warning.delete.save.operator.selection"
              onCloseModal={this.onCloseModal}
              deleteSelection={this.deleteSelection}
            />
            }
            <ul className="presets">
              {
              selections
                .filter(selection => selection.scope === 'USER')
                .map(selection =>
                (
                  <li
                    key={selection.name}
                    onClick={e => this.applySelection(e, selection)}
                    className={`preset-wrapper ${this.state.activeSelection === selection.name ? 'active' : ''}`}
                  >
                    <div className="preset-pill">
                      <span>
                        {selection.name}
                      </span>
                      { selection.name !== 'Your last selection' &&
                        <button
                          className="delete-icon pill-name"
                          key={selection.name}
                          onClick={e => this.openDeleteSelectionModal(e, selection)}
                        >
                          <Icons.Custom name="trash-o" />
                        </button>
                      }
                    </div>
                  </li>
                ))
            }
            </ul>
            <ul className="global-presets">
              {
                selections
                  .filter(selection => selection.scope === 'GLOBAL')
                  .map(selection =>
                    (
                      <li
                        key={selection.name}
                        onClick={e => this.applySelection(e, selection)}
                        className={`preset-wrapper ${this.state.activeSelection === selection.name ? 'active' : ''}`}
                      >
                        <div className="preset-pill">
                          <span>
                            {selection.name}
                          </span>
                          { selection.name !== 'Your last selection' &&
                          <button
                            className="delete-icon pill-name"
                            key={selection.name}
                            onClick={e => this.openDeleteSelectionModal(e, selection)}
                          >
                            <Icons.Custom name="trash-o" />
                          </button>
                          }
                        </div>
                      </li>
                    ))
              }
            </ul>
          </div>
        ) :
          <FormattedMessage id="app.selection.list.empty" />
        }
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => bindActionCreators({
  fetchUserProductSelectionsRequestActionCreator,
  deleteUserProductSelectionRequestActionCreator,
  mailClassSelected,
}, dispatch);

ProductSelectionHeaderBarContainer.propTypes = {
  selections: PropTypes.arrayOf(PropTypes.shape({
    scope: PropTypes.string,
    name: PropTypes.string.isRequired,
    products: PropTypes.arrayOf(PropTypes.shape({
      mailCategoryCode: PropTypes.string,
      mailSubClasses: PropTypes.arrayOf(PropTypes.string),
    })),
  })),
  fetchUserProductSelectionsRequestActionCreator: PropTypes.func,
  deleteUserProductSelectionRequestActionCreator: PropTypes.func,
  mailClassSelected: PropTypes.func,
  categoryOnlySelection: PropTypes.bool,
  mailClassNodes: PropTypes.arrayOf(PropTypes.shape),
};

export const ConnectedProductSelectionHeaderBarContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ProductSelectionHeaderBarContainer);

export default (ConnectedProductSelectionHeaderBarContainer);
